import React from "react";
import Navbar from "../../Common/Navbar/Navbar";
import Footer from "../Footer/Footer";
import "./Layout.css"
import GlobalMessage from "../GlobalMessage/GlobalMessage.js";

const Layout = ({ children }) => {
  return (
    <div className="layout-container">
      <Navbar />
      <GlobalMessage/>
      <div className="content-container">{children}</div>
      <Footer />
    </div>
  );
};

export default Layout;
